// extracted by mini-css-extract-plugin
export default {"questionVoteBox":"H2-z","upvote":"I2-z","downvote":"J2-z","numVotes":"K2-z","votesDescription":"L2-z","report":"M2-z","voted":"N2-z","answerVoteBox":"O2-z","justReported":"P2-z"};